import React from "react";
import { RADII, IconSize } from "../theme";
import styled from "@emotion/styled";
import { isPostnup } from "../../utils/branding";
import PostnupLogo from "./PostnupLogo";

const ringGradient = `conic-gradient(
  from 90deg,
  rgba(255, 255, 255, 0) 0deg,
  rgba(255, 191, 94, 0.5) 180deg,
  rgba(255, 191, 94, 1) 360deg
)`;

const Container = styled.div`
  position: relative;
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 8px;
`;

const RingContainer = styled.div`
  position: relative;
  width: 34px;
  height: 34px;
`;

const PostnupLogoContainer = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  width: 34px;
  height: 34px;
  animation: postnup-logo-fade 1.6s ease-in-out infinite;

  @keyframes postnup-logo-fade {
    0%,
    100% {
      opacity: 0.35;
    }
    50% {
      opacity: 1;
    }
  }
`;

const Ring = styled.div`
  position: absolute;
  background: ${ringGradient};
  height: 21px;
  width: 21px;
  mask: radial-gradient(transparent 7.5px, #000 0px);
  border-radius: ${RADII.circle};
  opacity: 1;
  animation: rotating 2s linear infinite;
  :before {
    content: "";
    display: block;
    padding-top: 100%;
  }
`;

const Ring1 = styled(Ring)`
  top: 14px;
  left: 1px;
`;
const Ring2 = styled(Ring)`
  top: 8px;
  left: 9px;
`;

const Heart1 = styled.div`
  position: absolute;
  top: -4px;
`;
const Heart2 = styled.div`
  position: absolute;
  transform: rotate(68deg);
  top: -8px;
  left: 25px;
`;

interface LoaderProps {
  spinnerOnly?: boolean;
  size?: number;
  text?: string;
}

const Heart = () => {
  return (
    <svg
      width="9"
      height="8"
      viewBox="0 0 9 8"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <mask
        id="mask0_9944_41957"
        style={{ maskType: "luminance" }}
        maskUnits="userSpaceOnUse"
        x="0"
        y="0"
        width="9"
        height="8"
      >
        <path d="M0.5 0.114441H8.44973V7.84484H0.5V0.114441Z" fill="white" />
      </mask>
      <g mask="url(#mask0_9944_41957)">
        <path
          d="M6.75192 0.275789C6.46585 0.176458 6.1615 0.142287 5.86032 0.169306C5.55994 0.195529 5.26592 0.286914 4.99971 0.431542C4.7335 0.579347 4.50067 0.78119 4.3179 1.02435C4.13115 1.26752 3.99447 1.54485 3.91819 1.84205L3.78866 2.33553L3.40802 2.237C2.21921 1.90245 0.966838 2.55645 0.608449 3.69678C0.467795 4.14178 0.463822 4.61619 0.597324 5.0612C0.734004 5.50621 0.997035 5.90115 1.35463 6.18643C1.59144 6.38033 1.86559 6.52098 2.15882 6.60442L6.37446 7.76779C6.45075 7.79084 6.52704 7.79402 6.6073 7.78289C6.68279 7.77177 6.75908 7.74872 6.82742 7.7066C6.89655 7.66846 6.95377 7.61601 7.00303 7.55085C7.04833 7.49046 7.08329 7.41815 7.10237 7.34186L8.19104 3.14926C8.49937 1.93264 7.85252 0.644509 6.75192 0.275789Z"
          fill="#0BA1F5"
        />
      </g>
    </svg>
  );
};

const Loader: React.FC<LoaderProps> = ({
  spinnerOnly = false,
  text = "Loading...",
}) => {
  return (
    <Container data-testid="loader-icon">
      {isPostnup ? (
        <PostnupLogoContainer>
          {/* Sized to the mark itself, matching the prenup branch's 21px ring
              rather than the container. */}
          <PostnupLogo size={IconSize.M} />
        </PostnupLogoContainer>
      ) : (
        <RingContainer>
          <Heart1>
            <Heart />
          </Heart1>
          <Heart2>
            <Heart />
          </Heart2>
          <Ring1 />
          <Ring2 />
        </RingContainer>
      )}
      {!spinnerOnly && <span>{text}</span>}
    </Container>
  );
};

export default Loader;
